// extracted by mini-css-extract-plugin
export default {"mainContainer":"EnvSwitch_mainContainer__Rg-bM","env":"EnvSwitch_env__IYiqU","activeEnv":"EnvSwitch_activeEnv__ssUQ8"};